var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("pet-title-component", { attrs: { title: _vm.name } }),
      _vm._v(" "),
      _c("div", { staticClass: "card-content" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "name-form-group",
                    label: _vm.$t("pets.pet.name"),
                    "label-for": "name-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: { id: "name-input", type: "text", placeholder: "" },
                    model: {
                      value: _vm.name,
                      callback: function($$v) {
                        _vm.name = $$v
                      },
                      expression: "name"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "species-form-group",
                    label: _vm.$t("pets.pet.species"),
                    "label-for": "species-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      id: "species-input",
                      type: "text",
                      placeholder: ""
                    },
                    model: {
                      value: _vm.species,
                      callback: function($$v) {
                        _vm.species = $$v
                      },
                      expression: "species"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "transponder-id-form-group",
                    label: _vm.$t("pets.pet.transponderId"),
                    "label-for": "transponder-id-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      id: "transponder-id-input",
                      type: "text",
                      placeholder: ""
                    },
                    model: {
                      value: _vm.transponderId,
                      callback: function($$v) {
                        _vm.transponderId = $$v
                      },
                      expression: "transponderId"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "birthdate-form-group",
                    label: _vm.$t("pets.pet.birthdate"),
                    "label-for": "birthdate-input"
                  }
                },
                [
                  _c("datepicker", {
                    staticClass: "o-form",
                    attrs: { id: "birthdate-input", format: "dd.MM.yyyy" },
                    model: {
                      value: _vm.birthdate,
                      callback: function($$v) {
                        _vm.birthdate = $$v
                      },
                      expression: "birthdate"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "veterinarian-form-group",
                    label: _vm.$t("pets.pet.veterinarian"),
                    "label-for": "veterinarian-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      id: "veterinarian-input",
                      type: "text",
                      placeholder: ""
                    },
                    model: {
                      value: _vm.veterinarian,
                      callback: function($$v) {
                        _vm.veterinarian = $$v
                      },
                      expression: "veterinarian"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "custody-after-death-form-group",
                    label: _vm.$t("pets.pet.custody"),
                    "label-for": "custody-after-death-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      id: "custody-after-death-input",
                      type: "text",
                      placeholder: ""
                    },
                    model: {
                      value: _vm.custodyAfterDeath,
                      callback: function($$v) {
                        _vm.custodyAfterDeath = $$v
                      },
                      expression: "custodyAfterDeath"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "notes-form-group",
                    label: _vm.$t("pets.pet.notes"),
                    "label-for": "notes-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: { id: "notes-input", type: "text", placeholder: "" },
                    model: {
                      value: _vm.notes,
                      callback: function($$v) {
                        _vm.notes = $$v
                      },
                      expression: "notes"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-331c6dc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-331c6dc2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/guardian/AllInfoPetComponent.vue
// module id = null
// module chunks = 